import FingerprintJS from '@fingerprintjs/fingerprintjs';

const STORAGE_KEY = 'visitorId';
const COOKIE_NAME = 'visitorId';
const COOKIE_MAX_AGE_DAYS = 100000;

const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 86400000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}; SameSite=Lax`;
};

const getCookie = (name: string): string | null => {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

  return m ? decodeURIComponent(m[1]) : null;
};

let inFlight: Promise<string> | null = null;

export async function ensureVisitorId(): Promise<string> {
  if (typeof window === 'undefined') return 'server';

  const fromLs = localStorage.getItem(STORAGE_KEY);
  if (fromLs) return fromLs;

  const fromCookie = getCookie(COOKIE_NAME);
  if (fromCookie) {
    localStorage.setItem(STORAGE_KEY, fromCookie);

    return fromCookie;
  }

  if (!inFlight) {
    inFlight = FingerprintJS.load()
      .then((agent) => agent.get())
      .then((res) => {
        const id = res.visitorId;
        localStorage.setItem(STORAGE_KEY, id);
        setCookie(COOKIE_NAME, id, COOKIE_MAX_AGE_DAYS);

        return id;
      })
      .catch(async () => {
        const id = crypto.randomUUID();
        localStorage.setItem(STORAGE_KEY, id);
        setCookie(COOKIE_NAME, id, COOKIE_MAX_AGE_DAYS);

        return id;
      })
      .finally(() => {
        setTimeout(() => {
          inFlight = null;
        }, 0);
      });
  }

  return inFlight;
}
